import Message from '@base/lib/Message';
import { multiAddAnimate } from '@base/product/animate';
import { nativeCartNum } from 'base/utils/app';
import site from 'pro/config/site'

export type IMiniCartState = {
    visible: boolean; // dropdown 的 visible
    reloadCount: number; // 触发 reload 事件
    reloadByBonusListCount: number; // 加购商品列表触发 reload 事件
    totalQty: number; // 同步购物车页面勾选商品的数量，目前只有购物车页面用到
    hasMiniCart: boolean; // 页面有没有minicart
}

export type IMiniCartStore = {
    state: IMiniCartState;
    setVisible: (visible: boolean) => void; // 显示或隐藏下拉菜单
    reload: () => void; // minicart 重新加载数据
    reloadByBonusList: () => void; // 加购商品列表触发 reload 事件
    afterAddCart: (qty: number, imgList?: string[], showMessage?: boolean) => void; // 加车后调用，统一处理交互
    setTotalQty: (qty: number) => void; // 同步购物车页面的数据，目前只有购物车页面用到
    activeMinicart: () => void; // 激活minicart
}

export const createMiniCartStore = (prevState?: IMiniCartState): IMiniCartStore => ({
    state: prevState || {
        visible: false,
        reloadCount: 0,
        reloadByBonusListCount: 0,
        totalQty: 0,
        hasMiniCart: false,
    },
    setVisible(visible) {
        this.state.visible = visible;
    },
    reload() {
        this.state.reloadCount += 1;
    },
    reloadByBonusList() {
        this.state.reloadByBonusListCount += 1;
    },
    afterAddCart(qty, srcList = [], showMessage = true) {
        // TODO: 暂时 vivohome 加车不展示mini Cart
        if (site.brand !== 'Vivohome') {
            this.setVisible(true);
        }
        if (this.state.hasMiniCart) {
            this.reload();
        } else {
            const totalQty = this.state.totalQty + (qty * (srcList?.length || 1))
            this.setTotalQty(totalQty);
            nativeCartNum(totalQty)

            if(showMessage) {
                if (srcList && srcList.length > 0 && document.getElementById('js-cart-icon')) {
                    multiAddAnimate(srcList);
                } else {
                    Message.success();
                }
            }

            if (site.brand !== 'Vivohome') {
                setTimeout(() => {
                    this.setVisible(false);
                }, 1);
            }
            // TODO: 暂时 vivohome 加车不展示mini Cart
            if (site.brand !== 'Vivohome') {
                // 恢复初始状态，为下次加车做准备
                setTimeout(() => {
                    this.setVisible(false);
                }, 1);
            }
        }
    },
    setTotalQty(qty) {
        this.state.totalQty = qty;
    },
    activeMinicart() {
        this.state.hasMiniCart = true;
    }
});

export default createMiniCartStore;
